/* eslint-disable */

// react imports
import React, { useState, useEffect } from "react";

// firebase imports
import { getDocs, collection, query, where, orderBy } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import Link from "@mui/material/Link";

// notistack imports
import { useSnackbar } from "notistack";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setOrderPage,
  setOrderPageEmpty,
  setChosenAddress,
  setFinalAddress,
  setCart,
  setEmptyCart,
  setLocalCustomization,
  setEditOrder,
  setActiveNavLink,
  setPageState,
} from "context";

// Firebase imports
import { db, auth } from "../../../../../../../Firebase";

export default function data() {
  const [rowArray, setRowArray] = useState([]);
  const [user] = useAuthState(auth);
  const [controller, dispatch] = useMaterialUIController();
  const { userStores } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const avatars = (members) =>
      members.map(([image, key, title]) => (
        <Tooltip key={key} title={title} placeholder="bottom">
          <MDAvatar
            src={image}
            alt="name"
            size="md"
            variant="square"
            sx={{
              border: ({ borders: { borderWidth }, palette: { white } }) =>
                `${borderWidth[2]} solid ${white.main}`,
              cursor: "pointer",
              position: "relative",

              "&:not(:first-of-type)": {
                ml: { xs: 0, sm: -1.25 },
              },

              "&:hover, &:focus": {
                zIndex: "10",
              },
            }}
          />
        </Tooltip>
      ));
    const itemList = (items) =>
      items.map(([key, title, quantity]) => (
        <div key={key}>
          {title}: {quantity}
        </div>
      ));

    const setNewDocument = async () => {
      if (user) {
        const newArray = [];
        userStores.forEach(async (study) => {

          const orderDocs = collection(db, `${study}_ORDERS`);

          const q = query(
            orderDocs,
            // where("orderFor", "==", `${user.email}`),
            orderBy("date_created", "desc")
          );
          const newDoc = await getDocs(q);
          const parsedDocs = newDoc.docs.map((el) => el.data().orderFor == `${user.email}` && ({ ...el.data(), id: el.id }));

          for (const element of parsedDocs) {
            console.log(element);
            if (element.items && element.items.length > 0){
              const itemArray = element.items.map((x) => [x.image, x.newID, x.title]);
              const itemListArray = element.items.map((x) => [x.title, x.title, x.cartQuantity]);
              const elementArray = {
                study: (<>
                  <MDBox
                    // pb={5}
                  >
                    <strong>
                      {element.storeData.title}
                    </strong>
                  </MDBox>
                </>),
                companies: (<>
                  <MDBox py={2}>
                    <MDBox px={0.5}>
                      <MDTypography
                        color="secondary"
                        sx={{ fontSize: '14px' }}
                      >
                        <strong>
                          {/* Order # */}
                          {/* {" "} */}
                          {element.orderId}
                          </strong>
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </>),
                completion: (<>
                  <MDBox width="8rem">
                    <MDBadge
                      badgeContent={element.status}
                      color={element.statusColor}
                      size="lg"
                      container
                    />
                  </MDBox>
                </>
                ),
                date: (
                  <>
                    <MDBox>
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        textAlign="left"
                      >
                        Created:
                      </MDTypography>
                      {" "}
                      <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                        {element.date_created.toDate().toLocaleDateString("en-us", {
                          weekday: "long",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDTypography
                        variant="caption"
                        fontWeight="medium"
                        textAlign="left"
                      >
                        Updated:
                      </MDTypography>
                      {" "}
                      <MDTypography
                        variant="caption"
                        color={element.statusColor}
                        fontWeight="medium"
                        textAlign="left"
                      >
                        {element.date_modified.toDate().toLocaleDateString("en-us", {
                          weekday: "long",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </MDTypography>
                    </MDBox>
                  </>
                ),
                members: (<>
                  <MDBox>
                    <MDBox display="flex" py={1}>
                      {avatars(itemArray)}
                    </MDBox>
                    <MDBox display="flex" py={1}>
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontWeight="medium"
                        textAlign="left"
                      >
                        {itemList(itemListArray)}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox pt={2} pb={0.5} sx={{ transform: 'scale(0.925)', transformOrigin: 'left' }}>
                    <MDButton
                      variant="outlined"
                      color="secondary"
                      sx={{
                        padding: '5px 8px',
                        minHeight: '30px'
                      }}
                      onClick={() => {
                        setOrderPage(dispatch, element);
                        setOrderPageEmpty(dispatch, false);
                        setPageState(dispatch, "OrderPage");
                      }}
                    >
                      view order
                    </MDButton>
                    {" "}{" "}
                    <MDButton
                      variant="outlined"
                      color="secondary"
                      sx={{
                        padding: '5px 8px',
                        minHeight: '30px'
                      }}
                      onClick={() => {
                        let customization = {
                          customized: false,
                          clinicName: "",
                          line2: "",
                          line3: "",
                        };
                        if (element.customization !== undefined) {
                          customization = {
                            customized: element.customization.customized,
                            clinicName: element.customization.clinicName,
                            line2: element.customization.line2,
                            line3: element.customization.line3,
                          };
                        }
                        setLocalCustomization(dispatch, customization);
                        window.localStorage.setItem("customization", JSON.stringify(customization));
                        setChosenAddress(dispatch, {
                          nickName: element.shippingAddress.nickName,
                          attn: element.shippingAddress.attn,
                          email: element.shippingAddress.email,
                          phone: element.shippingAddress.phone,
                          country: element.shippingAddress.country,
                          addressLine1: element.shippingAddress.addressLine1,
                          addressLine2: element.shippingAddress.addressLine2,
                          addressLine3: element.shippingAddress.addressLine3,
                          city: element.shippingAddress.city,
                          zip: element.shippingAddress.zip,
                          state: element.shippingAddress.state,
                          clinic: element.shippingAddress.clinic,
                        });
                        setFinalAddress(dispatch, {
                          nickName: element.shippingAddress.nickName,
                          attn: element.shippingAddress.attn,
                          email: element.shippingAddress.email,
                          phone: element.shippingAddress.phone,
                          country: element.shippingAddress.country,
                          addressLine1: element.shippingAddress.addressLine1,
                          addressLine2: element.shippingAddress.addressLine2,
                          addressLine3: element.shippingAddress.addressLine3,
                          city: element.shippingAddress.city,
                          zip: element.shippingAddress.zip,
                          state: element.shippingAddress.state,
                          clinic: element.shippingAddress.clinic,
                        });
                        setCart(
                          dispatch,
                          element.items.map((item) => ({ ...item, study: element.storeData.title }))
                        );
                        setEmptyCart(dispatch, false);
                        setEditOrder(dispatch, true);
                        setActiveNavLink(dispatch, "checkout");
                        const variant = "success";
                        enqueueSnackbar(`Order #: ${element.orderId} has been added to checkout!`, {
                          variant,
                          autoHideDuration: 2000,
                        });
                        setPageState(dispatch, "Review");
                      }}
                    >
                      order again
                    </MDButton>
                </MDBox>
                </>),
                budget: (
                  <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                    Attn: {element.shippingAddress.attn}
                    <br />
                    {element.shippingAddress.addressLine1}
                    <br />
                    {element.shippingAddress.addressLine2.length === 0 ? (
                      ""
                    ) : (
                      <>
                        {element.shippingAddress.addressline2} <br />
                      </>
                    )}
                    {element.shippingAddress.addressLine3.length === 0 ? (
                      ""
                    ) : (
                      <>
                        {element.shippingAddress.addressline3} <br />
                      </>
                    )}
                    {element.shippingAddress.city}, {element.shippingAddress.state}
                    {" "}
                    {element.shippingAddress.zip}
                    <br />
                    {element.shippingAddress.country}
                    <br />
                    {[0].map((object, idx) => {
                      let tracking = {}
                      for (const item of element.statusTimeline){
                        if (item.tracking && item.tracking.numb){
                          const trackingProvider = item.tracking.name.toLowerCase();
                          if (trackingProvider === 'fedex'){
                            item.tracking.name = 'FedEx';
                            item.tracking.link = `https://www.fedex.com/fedextrack/?trknbr=${item.tracking.numb}`;
                          } else if (trackingProvider === 'dhl'){
                            item.tracking.name = 'DHL';
                            item.tracking.link = `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${item.tracking.numb}`;
                          } else if (trackingProvider === 'usps'){
                            item.tracking.name = 'USPS';
                            item.tracking.link = `https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${item.tracking.numb}%2C&tABt=false`;
                          }
                          tracking = { ...item.tracking }
                        }
                      }
                      return (<React.Fragment key={idx}>
                        {tracking.numb && <>
                          <br />
                          <strong>{tracking.name}:</strong>
                          {" "}
                          <span>{tracking.numb}</span>
                          <MDBox sx={{ textDecoration: "underline" }}>
                            <Link target="_blank" rel="noreferrer" href={tracking.link}>Track package</Link>
                          </MDBox>
                        </>}
                      </React.Fragment>)
                    })}
                  </MDTypography>
                ),
              };
              newArray.push(elementArray);
            }
          }

        });
        setRowArray(newArray);
      }
    };
    setNewDocument();
    setTimeout(() => {
      setIsLoading(false);
    }, 250);
  }, [userStores]);

  return {
    columns: [
      { Header: "order #", accessor: "companies", width: "10%", align: "left" },
      { Header: "study", accessor: "study", width: "15%", align: "left" },
      { Header: "items", accessor: "members", width: "20%", align: "left" },
      { Header: "shipping", accessor: "budget", width: "30%", align: "left" },
      { Header: "status", accessor: "completion", width: "10%", align: "left" },
      { Header: "date", accessor: "date", width: "15%", align: "left" },
    ],

    rows: rowArray,

    loading: isLoading,
  };
}
